const PREFIX = '/v1/CollectiveProject/CollectiveOwnedProjectSecurityService'

export const URL = {
  ADD: PREFIX + '/add',
  DEL: PREFIX + '/delete',
  EDIT: PREFIX + '/edit',
  LIST: PREFIX + '/list',
  DETAIL: PREFIX + '/view',
  ENABLE: PREFIX + '/able',
  DISABLE: PREFIX + '/disable',
  ORDER: PREFIX + '/order',
  REVIEW_LIST: PREFIX + '/shenHeList',
  SECURITY_FILES_PREVIEW: PREFIX + '/securityFilesView'
}
